import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import {CardCompanyAboutUs} from '../../components/Cards/Company/AboutUs';
import {CardCompanyInfo} from '../../components/Cards/Company/Info';
import {CompanyAreas} from '../../components/CommonComponents';
import {ROUTES} from '../../db/models/const';
import {selectUser} from '../../slices/profile';
import {getCompanyAreas, getCompanyById} from '../../api/company';

export const StudentCompanyExplore = () => {
    const [tab, setTab] = useState(0);
    const {companyId} = useParams();
    const [company, setCompany] = useState();
    const [areas, setAreas] = useState([]);
    const {t} = useTranslation();
    const history = useHistory();
    const user = useSelector(selectUser);

    useEffect(() => {
        if (!companyId || !user) return;

        getCompanyById(companyId).then(company => {
            if (!user?.demo && company.demo) {
                history.push(ROUTES.STUDENT_HOME);
                return;
            }

            setCompany(company);
            getCompanyAreas(companyId).then((areas) => {
                // const storeAreas = {
                // 	type: STORE_AREAS,
                // 	payload: { areas: areas || [] },
                // };
                // dispatch(storeAreas);
                setAreas(areas);
            });
        });
    }, [companyId, user]);

    return (
        <div className="studentCompanyExplore">
            <CardCompanyInfo company={company} editable={false}/>

            <div className="tabs">
                <div className={`tab ${tab === 0 ? "tab--active" : ""}`}
                     onClick={() => setTab(0)}>{t("student_company_who")}</div>
                <div className={`tab ${tab === 1 ? "tab--active" : ""}`}
                     onClick={() => setTab(1)}>{t("student_company_paths")}</div>
            </div>
            <div>
                {tab === 0 && <CardCompanyAboutUs company={company}/>}
                {tab === 1 && <CompanyAreas areas={areas} companyId={companyId}/>}
            </div>
        </div>
    );
};